import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import ChoiceView from "../ChoiceView";
import WizardStepDialog from "./WizardStepDialog";
import { LOCATION_SNAPSHOT_ADD_ITEM_STEPS, getLocationSnapshotAddItemStepMeta } from "../../steps";

const { CHOICE } = LOCATION_SNAPSHOT_ADD_ITEM_STEPS;

export default function ChoiceStepDialog({ open, locationName, onClose, onSearch, onNew }) {
  const { step, steps } = getLocationSnapshotAddItemStepMeta(CHOICE);

  return (
    <WizardStepDialog
      open={open}
      title={`Add Inventory to ${locationName}`}
      onClose={onClose}
      step={step}
      steps={steps}
      actions={
        <Box display="flex" gap={1}>
          <Button variant="outlined" onClick={onSearch} startIcon={<SearchIcon />}>
            Item Already Exists
          </Button>
          <Button variant="contained" onClick={onNew} startIcon={<AddIcon />}>
            Create New Item
          </Button>
        </Box>
      }
    >
      <ChoiceView />
    </WizardStepDialog>
  );
}
